import { combineReducers } from "redux";
import {
  changePassword_reducer,
  forgotPassword_reducer,
  local_varaibles,
  login_reducer,
  logout_reducer,
  notifications_reducer,
  request_demo_reducer,
  resetPassword_reducer,
} from "./actions/auth/reducer";
import {
  account_txns_reducer,
  add_categories_reducer,
  categories_reducer,
  categories_status_reducer,
  delete_categories_reducer,
} from "./actions/categories/reducer";
import {
  dashboard_reducer,
  error_modal_reducer,
} from "./actions/dashboard/reducer";
import {
  add_employees_reducer,
  delete_employees_reducer,
  download_link_reducer,
  employees_reducer,
  employees_status_reducer,
  get_user_fields_reducer,
  profile_reducer,
  update_employees_reducer,
  upload_bulk_employees_reducer,
  users_list_reducer,
} from "./actions/employees/reducer";
import {
  addUserReports_reducer,
  reportdetails_pdf_reducer,
  reportsAdvance_reducer,
  reportsApprove_reducer,
  reportsBulkApproveReject_reducer,
  reportsCommentsAdd_reducer,
  reportsComments_reducer,
  reportsExpAddComments_reducer,
  reportsExpComments_reducer,
  reportsExpDetails_reducer,
  reportsExpHistory_reducer,
  reportsHistory_reducer,
  reportsReimburse_reducer,
  reportsReject_reducer,
  reportsTrips_reducer,
  reports_count_reducer,
  reports_reducer,
  transactionsPartialApprove_reducer,
  transactionsReject_reducer,
  userReportFields_reducer,
  userReportLinkAdv_reducer,
  userReportLinkExp_reducer,
  userReportRecall_reducer,
  userReportSubmit_reducer,
  userReports_reducer,
  user_report_reducer,
} from "./actions/reports/reducer";

import {
  addExpense_reducer,
  create_expensePolicies_reducer,
  delete_expensePolicies_reducer,
  delete_expense_reducer,
  edit_expensePolicies_reducer,
  expenseDetails_reducer,
  expenseFields_reducer,
  expenses_reducer,
  expense_comments_reducer,
  list_expensePolicies_reducer,
  show_expensePolicies_reducer,
  expenseFiles_reducer,
} from "./actions/expenses/reducer";

import {
  addUserTrip_reducer,
  attach_files_to_trips_reducer,
  download_trip_attachment_reducer,
  tripsAddComments_reducer,
  tripsApprove_reducer,
  tripsComments_reducer,
  tripsHistory_reducer,
  tripsReject_reducer,
  trips_close_reducer,
  trips_reducer,
  trips_show_reducer,
  trip_detail_pdf_reducer,
  trip_recall_reducer,
  userReportLinkTrips_reducer,
  userTripFields_reducer,
  userTripsSubmit_reducer,
  userTrips_reducer,
} from "./actions/trips/reducer";

import {
  activate_card_reducer,
  analytics_cards_export_reducer,
  analytics_cards_reducer,
  analytics_cards_all_reducer,
  block_reducer,
  cardsDetails_reducer,
  cards_reducer,
  card_enable_limit_reducer,
  card_policies_reducer,
  card_set_policies_reducer,
  corporate_budget_reducer,
  delete_card_policy_reducer,
  download_bulk_reducer,
  get_card_limit,
  get_card_policies,
  quick_logs_reducer,
  remind_card_activation_reducer,
  replacement_reducer,
  send_otp_reducer,
  set_card_policy_reducer,
  set_pin_reducer,
  show_card_policy_reducer,
  topup_reducer,
  transactions_reducer,
  transfer_logs_reducer,
  update_mobile_reducer,
  upload_bulk_reducer,
  userCards_reducer,
  verify_otp_reducer,
  block_reasons_reducer,
  top_up_reducer,
  cards_transfer_reducer,
  checker_transfers_reducer,
  user_logs_reducer,
} from "./actions/cards/reducer";

import {
  addUserAdvance_reducer,
  advancesApprove_reducer,
  advancesCommentsAdd_reducer,
  advancesComments_reducer,
  advancesExpAddComments_reducer,
  advancesExpComments_reducer,
  advancesExpDetails_reducer,
  advancesExpHistory_reducer,
  advancesHistory_reducer,
  advancesReject_reducer,
  advances_reducer,
  advance_pdf_reducer,
  advance_show_reducer,
  updateUserAdvance_reducer,
  userAdvanceDelete_reducer,
  userAdvanceFields_reducer,
  userAdvancesSubmit_reducer,
  userAdvances_reducer,
} from "./actions/advances/reducer";
import {
  add_advancesField_reducer,
  add_companySetting_reducer,
  add_costCenterField_reducer,
  add_designations_reducer,
  add_merchantsField_reducer,
  add_projectsField_reducer,
  add_reportField_reducer,
  add_roles_reducer,
  add_transactionField_reducer,
  add_tripsField_reducer,
  add_userFields_reducer,
  advanceApproval_reducer,
  companyCities_reducer,
  companyCountries_reducer,
  companyProfile_reducer,
  companySetting_reducer,
  companyStates_reducer,
  delete_advancesField_reducer,
  delete_costCenterField_reducer,
  delete_designations_reducer,
  delete_merchantsField_reducer,
  delete_projectsField_reducer,
  delete_reportField_reducer,
  delete_role_reducer,
  delete_transactionField_reducer,
  delete_tripsField_reducer,
  delete_userFields_reducer,
  get_advancesField_reducer,
  get_costCenterField_reducer,
  get_custom_fields_reducer,
  get_designations_reducer,
  get_merchantsField_reducer,
  get_projectsField_reducer,
  get_reportField_reducer,
  get_rolesPermissions_reducer,
  get_roles_reducer,
  get_singleRoles_reducer,
  get_singleUserFields_reducer,
  get_single_designations_reducer,
  get_transactionField_reducer,
  get_tripsField_reducer,
  get_userFieldsColumnTypes_reducer,
  get_userFields_reducer,
  orgs_reducer,
  reportsApproval_reducer,
  tripApproval_reducer,
  updateAdvanceApproval_reducer,
  updateCompanyProfile_reducer,
  updateCompanyTrips_reducer,
  updateReportsApproval_reducer,
  updateTripApproval_reducer,
  update_advancesField_reducer,
  update_advancesreport_reducer,
  update_companyreport_reducer,
  update_companytransaction_reducer,
  update_costCenterField_reducer,
  update_designations_reducer,
  update_merchantsField_reducer,
  update_projectsField_reducer,
  update_reportField_reducer,
  update_roles_reducer,
  update_transactionField_reducer,
  update_tripsField_reducer,
  update_userFields_reducer,
} from "./actions/companySettings/reducer";
import {
  create_dispute_comments_reducer,
  create_disputes_reducer,
  dispute_comments_reducer,
  disputes_reducer,
  update_disputes_reducer,
} from "./actions/disputes";
import {
  create_beneficiary_reducer,
  get_beneficiary_reducer,
  get_by_id_beneficiary_reducer,
} from "./actions/beneficiary/reducer";

export default combineReducers({
  auth: combineReducers({
    login: login_reducer,
    logout: logout_reducer,
    resetPassword: resetPassword_reducer,
    forgotPassword: forgotPassword_reducer,
    changePassword: changePassword_reducer,
    localVariables: local_varaibles,
    notifications: notifications_reducer,
    requestDemo: request_demo_reducer,
  }),
  dashboard: combineReducers({
    dashboard: dashboard_reducer,
  }),
  expenses: combineReducers({
    expenses: expenses_reducer,
    expenseDetails: expenseDetails_reducer,
    addExpense: addExpense_reducer,
    expenseFields: expenseFields_reducer,
    expenseFiles: expenseFiles_reducer,
    policies: list_expensePolicies_reducer,
    create_policies: create_expensePolicies_reducer,
    edit_policies: edit_expensePolicies_reducer,
    show_policy: show_expensePolicies_reducer,
    delete_policy: delete_expensePolicies_reducer,
    comments: expense_comments_reducer,
  }),
  reports: combineReducers({
    reports: reports_reducer,
    reportsReject: reportsReject_reducer,
    transactionsReject: transactionsReject_reducer,
    deleteExpense: delete_expense_reducer,
    transactionsPartialApprove: transactionsPartialApprove_reducer,
    reportsApprove: reportsApprove_reducer,
    reportsExpDetails: reportsExpDetails_reducer,
    reportsExpComments: reportsExpComments_reducer,
    reportsExpAddComments: reportsExpAddComments_reducer,
    reportsComments: reportsComments_reducer,
    reportsCommentsAdd: reportsCommentsAdd_reducer,
    reportsHistory: reportsHistory_reducer,
    reportsAdvance: reportsAdvance_reducer,
    reportsTrips: reportsTrips_reducer,
    reportsExpHistory: reportsExpHistory_reducer,
    reportsReimburse: reportsReimburse_reducer,
    userReports: userReports_reducer,
    userReportFields: userReportFields_reducer,
    userReportLinkExp: userReportLinkExp_reducer,
    userReportLinkAdv: userReportLinkAdv_reducer,
    userReportSubmit: userReportSubmit_reducer,
    userReportRecall: userReportRecall_reducer,
    userReportShow: user_report_reducer,
    addUserReports: addUserReports_reducer,
    bulkApprove: reportsBulkApproveReject_reducer,
    reportdetailsPdf: reportdetails_pdf_reducer,
  }),

  trips: combineReducers({
    trips: trips_reducer,
    tripsClose: trips_close_reducer,
    tripsRecall: trip_recall_reducer,
    userTrips: userTrips_reducer,
    userTripsSubmit: userTripsSubmit_reducer,
    addUserTrip: addUserTrip_reducer,
    userTripFields: userTripFields_reducer,
    tripsReject: tripsReject_reducer,
    tripsApprove: tripsApprove_reducer,
    tripsComments: tripsComments_reducer,
    tripsCommentsAdd: tripsAddComments_reducer,
    tripsHistory: tripsHistory_reducer,
    tripsShow: trips_show_reducer,
    tripDetailPDF: trip_detail_pdf_reducer,
    userReportLinkTrips: userReportLinkTrips_reducer,
    download_trip_attachment: download_trip_attachment_reducer,
    attach_files_to_trip: attach_files_to_trips_reducer,
  }),
  cards: combineReducers({
    userCards: userCards_reducer,
    cards: cards_reducer,
    setPin: set_pin_reducer,
    cardsDetails: cardsDetails_reducer,
    transactions: transactions_reducer,
    topup: topup_reducer,
    block: block_reducer,
    uploadBulk: upload_bulk_reducer,
    downloadBulk: download_bulk_reducer,
    replacement: replacement_reducer,
    corporate_budget: corporate_budget_reducer,
    transferLogs: transfer_logs_reducer,
    quick_logs: quick_logs_reducer,
    userLogs: user_logs_reducer,
    cartSetPolicies: card_set_policies_reducer,
    cardPolicies: card_policies_reducer,
    card_limit: get_card_limit,
    get_card_policies: get_card_policies,
    card_enable: card_enable_limit_reducer,
    show_card_policy: show_card_policy_reducer,
    delete_card_policy: delete_card_policy_reducer,
    set_card_policy: set_card_policy_reducer,
    reports_count: reports_count_reducer,
    update_mobile: update_mobile_reducer,
    send_otp: send_otp_reducer,
    verify_otp: verify_otp_reducer,
    activate_card: activate_card_reducer,
    remind_card_activation: remind_card_activation_reducer,
    block_reasons: block_reasons_reducer,
    top_up: top_up_reducer,
    cardsTransferData: cards_transfer_reducer,
    profile: profile_reducer,
  }),

  advances: combineReducers({
    userAdvances: userAdvances_reducer,
    userAdvancesSubmit: userAdvancesSubmit_reducer,
    userAdvanceFields: userAdvanceFields_reducer,
    addUserAdvance: addUserAdvance_reducer,
    advances: advances_reducer,
    advancesApprove: advancesApprove_reducer,
    advancesReject: advancesReject_reducer,
    userAdvanceDelete: userAdvanceDelete_reducer,
    advancesExpDetails: advancesExpDetails_reducer,
    advancesExpComments: advancesExpComments_reducer,
    advancesExpAddComments: advancesExpAddComments_reducer,
    advancesComments: advancesComments_reducer,
    advancesCommentsAdd: advancesCommentsAdd_reducer,
    advancesHistory: advancesHistory_reducer,
    advancesExpHistory: advancesExpHistory_reducer,
    advance_pdf: advance_pdf_reducer,
    updateUserAdvance: updateUserAdvance_reducer,
    show_advance: advance_show_reducer,
  }),
  account: combineReducers({
    txns: account_txns_reducer,
  }),
  categories: combineReducers({
    categories: categories_reducer,
    categoriesStatus: categories_status_reducer,
    addCategories: add_categories_reducer,
    deleteCategories: delete_categories_reducer,
  }),

  employees: combineReducers({
    employees: employees_reducer,
    employeesStatus: employees_status_reducer,
    addEmployees: add_employees_reducer,
    deleteEmployees: delete_employees_reducer,
    updateEmployees: update_employees_reducer,
  }),
  users: combineReducers({
    downloadLink: download_link_reducer,
    upload: upload_bulk_employees_reducer,
    user_fields: get_user_fields_reducer,
    list: users_list_reducer,
  }),
  transfers: combineReducers({
    getTransfersData: checker_transfers_reducer,
  }),
  analytics: combineReducers({
    analytics_cards: analytics_cards_reducer,
    analytics_cards_all: analytics_cards_all_reducer,
    analytics_cards_export: analytics_cards_export_reducer,
  }),
  companySetting: combineReducers({
    orgs: orgs_reducer,
    companyProfile: companyProfile_reducer,
    updateCompanyProfile: updateCompanyProfile_reducer,
    reportsApproval: reportsApproval_reducer,
    updateReportsApproval: updateReportsApproval_reducer,
    advanceApproval: advanceApproval_reducer,
    updateAdvanceApproval: updateAdvanceApproval_reducer,
    tripApproval: tripApproval_reducer,
    updateTripApproval: updateTripApproval_reducer,
    companySetting: companySetting_reducer,
    updateCompanySetting: add_companySetting_reducer,
    updateTransactionReport: update_companytransaction_reducer,
    getTransactionField: get_transactionField_reducer,
    addTransactionField: add_transactionField_reducer,
    deleteTransactionField: delete_transactionField_reducer,
    updateTransactionField: update_transactionField_reducer,
    updateCompanyReport: update_companyreport_reducer,
    getReportField: get_reportField_reducer,
    addReportField: add_reportField_reducer,
    deleteReportField: delete_reportField_reducer,
    updateReportField: update_reportField_reducer,
    updateAdvancesReport: update_advancesreport_reducer,
    getAdvancesField: get_advancesField_reducer,
    addAdvancesField: add_advancesField_reducer,
    deleteAdvancesField: delete_advancesField_reducer,
    updateAdvancesField: update_advancesField_reducer,
    getCostCenterField: get_costCenterField_reducer,
    addCostCenterField: add_costCenterField_reducer,
    deleteCostCenterField: delete_costCenterField_reducer,
    updateCostCenterField: update_costCenterField_reducer,
    getMerchantsField: get_merchantsField_reducer,
    addMerchantsField: add_merchantsField_reducer,
    deleteMerchantsField: delete_merchantsField_reducer,
    updateMerchantsField: update_merchantsField_reducer,
    getProjectsField: get_projectsField_reducer,
    addProjectsField: add_projectsField_reducer,
    deleteProjectsField: delete_projectsField_reducer,
    updateProjectsField: update_projectsField_reducer,
    getTripsField: get_tripsField_reducer,
    addTripsField: add_tripsField_reducer,
    deleteTripsField: delete_tripsField_reducer,
    updateTripsField: update_tripsField_reducer,
    updateCompanyTrips: updateCompanyTrips_reducer,
    getRolesPermissions: get_rolesPermissions_reducer,
    getRoles: get_roles_reducer,
    getSingleRoles: get_singleRoles_reducer,
    addRoles: add_roles_reducer,
    updateRoles: update_roles_reducer,
    getDesignations: get_designations_reducer,
    addDesignations: add_designations_reducer,
    delete_role: delete_role_reducer,
    deleteDesignations: delete_designations_reducer,
    updateDesignations: update_designations_reducer,
    getSingleDesignations: get_single_designations_reducer,
    getUserFields: get_userFields_reducer,
    getCustomFields: get_custom_fields_reducer,
    getUserFieldsColumnTypes: get_userFieldsColumnTypes_reducer,
    getSingleUserFields: get_singleUserFields_reducer,
    addUserFields: add_userFields_reducer,
    deleteUserFields: delete_userFields_reducer,
    updateUserFields: update_userFields_reducer,
    companyCities: companyCities_reducer,
    companyStates: companyStates_reducer,
    companyCountries: companyCountries_reducer,
  }),
  disputes: combineReducers({
    create: create_disputes_reducer,
    all: disputes_reducer,
    update: update_disputes_reducer,
    create_comments: create_dispute_comments_reducer,
    comments: dispute_comments_reducer,
  }),
  beneficiary: combineReducers({
    beneficiaryData: get_beneficiary_reducer,
    createBeneficiaryData: create_beneficiary_reducer,
    beneficiaryDataByID: get_by_id_beneficiary_reducer,
  }),
  errorModal: error_modal_reducer,
});
